<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑分类' : '新增分类'"
      :visible.sync="showAddOrEdit"
      width="800px"
      :before-close="cancelFun"
      class="category-dialog"
    >
      <div class="dialog-content">
        <el-form ref="form" :model="formData" class="wrapper-form" label-width="120px">
          <el-form-item label="分类名称" prop="categoryName" :rules="rules">
            <el-input
              v-model="formData.categoryName"
              placeholder="请输入分类名称"
              maxlength="64"
              clearable
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="封面图" prop="coverImage" :rules="rules">
            <FileUpload :name.sync="formData.coverImage" :url="formData.coverImageUrl"></FileUpload>
          </el-form-item>
          <el-form-item label="权重" prop="weight" :rules="rules">
            <el-input-number
              v-model="formData.weight"
              :precision="0"
              :step="1"
              :min="1"
              :controls="false"
              placeholder="请输入权重"
              class="form-input-number"
            ></el-input-number>
            <span class="form-tip">数字越大越靠前</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun" class="cancel-btn">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun" class="submit-btn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/components/file-upload/index.vue';
import { getDetailAPI, addAPI, editAPI } from './api';

export default {
  name: 'StoreGoodsCategoryAddOrEdit',
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      formData: {
        categoryName: '',
        coverImage: '',
        coverImageUrl: '',
        weight: 1
      }
    }
  },
  mounted() {
    if (this.rowId) this.getCategoryDetail();
  },
  methods: {
    async getCategoryDetail() {
      this.formData = await getDetailAPI(this.rowId);
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('新增成功');
              this.$emit("closeDialog", true);
            })
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

// 对话框样式
::v-deep .category-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1);
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      border-bottom: none;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
      }
      
      .el-dialog__headerbtn {
        top: 20px;
        right: 24px;
        
        .el-dialog__close {
          font-size: 20px;
          color: #fff;
          transition: all 0.3s ease;
          
          &:hover {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
      background: #ffffff;
    }
    
    .el-dialog__footer {
      padding: 20px 28px;
      background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
      border-top: 2px solid #f0f2f5;
    }
  }
}

.dialog-content {
  padding: 24px 28px;
  max-height: 60vh;
  overflow-y: auto;
  
  // 自定义滚动条
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
    
    &:hover {
      background: #909399;
    }
  }
}

.wrapper-form {
  .el-form-item {
    margin-bottom: 24px;
    
    .el-form-item__label {
      color: #303133;
      font-weight: 600;
      letter-spacing: 0.3px;
      font-size: 14px;
      position: relative;
      
      &::after {
        content: ':';
        margin-left: 2px;
        color: #909399;
      }
    }
    
    .el-form-item__content {
      .form-input {
        width: 400px;
        
        ::v-deep .el-input__inner {
          border-radius: 10px;
          height: 42px;
          line-height: 42px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #fafbfc;
          font-size: 14px;
          padding-left: 15px;

          &:hover {
            border-color: #C0C4CC;
            background: #ffffff;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
      }
      
      .form-input-number {
        width: 400px;
        
        ::v-deep {
          .el-input-number__decrease,
          .el-input-number__increase {
            display: none;
          }
          
          .el-input {
            .el-input__inner {
              border-radius: 10px;
              height: 42px;
              line-height: 42px;
              border: 1.5px solid #E4E7ED;
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
              background: #fafbfc;
              font-size: 14px;
              text-align: left;
              padding: 0 15px;
              box-sizing: border-box;

              &:hover {
                border-color: #C0C4CC;
                background: #ffffff;
              }
              
              &:focus {
                border-color: #409EFF;
                box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
                background: #ffffff;
              }
            }
          }
        }
      }
      
      .form-tip {
        margin-left: 12px;
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .cancel-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
    border: none;
    box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #909399 0%, #82848a 100%);
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    }
  }
  
  .submit-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }
  }
}

// 文件上传组件样式优化
::v-deep .avatar-uploader {
  .el-upload {
    border: 2px dashed #d9d9d9;
    border-radius: 12px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    background: #fafbfc;
    
    &:hover {
      border-color: #409EFF;
      background: #f0f7ff;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
    }
  }
  
  .avatar-uploader-icon {
    font-size: 32px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    transition: all 0.3s ease;
    
    &:hover {
      color: #409EFF;
    }
  }
  
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  ::v-deep .category-dialog {
    .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
    
    .el-dialog__header {
      padding: 16px 20px;
    }
    
    .el-dialog__footer {
      padding: 16px 20px;
    }
  }
  
  .dialog-content {
    padding: 16px 20px;
  }
  
  .wrapper-form {
    .el-form-item {
      .el-form-item__content {
        .form-input,
        .form-input-number {
          width: 100% !important;
        }
      }
    }
  }
}
</style>
